import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bce0687&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0bce0687&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce0687",
  null
  
)

export default component.exports
import {QBanner,QIcon,QSelect,QItem,QItemSection,QSlider,QRadio,QCheckbox,QField,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBanner,QIcon,QSelect,QItem,QItemSection,QSlider,QRadio,QCheckbox,QField,QInput})
